import {
  GET_SALESFORCE_DESCRIBE_EXE_EXPORT_REQUEST,
  GET_SALESFORCE_DESCRIBE_EXE_EXPORT_SUCCESS,
  GET_SALESFORCE_DESCRIBE_EXE_EXPORT_FAILURE,
  POST_SALESFORCE_EXPORT_MAPPINGS_EXE_REQUEST,
  POST_SALESFORCE_EXPORT_MAPPINGS_EXE_SUCCESS,
  POST_SALESFORCE_EXPORT_MAPPINGS_EXE_FAILURE,
  GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST,
  GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS,
  GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE,
  LOG_OUT_SUCCESS,
} from "../../constants/ActionTypes";
import * as errMessages from "../../constants/ErrorMessages";
import * as messages from "../../constants/Messages";
import { formatErrorMessage } from "../../utils/utils";
import { isExpiredAccessError } from "../../utils/salesforceUtils";

const initialState = {
  errorMessage: "",
  shortMessage: "",
  successMessage: "",
  expiredAccessError: false,
  isLoadingFields: false,
  contactFields: {},
  accountFields: {},
  leadFields: {},
  isConfiguring: false,
  mapping: {},
  isLoadingMapping: false,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: "",
    successMessage: "",
    errorMessage: "",
    expiredAccessError: false,
  };

  let contactFields, accountFields, leadFields;
  switch (action.type) {
    case GET_SALESFORCE_DESCRIBE_EXE_EXPORT_REQUEST:
      return {
        ...state,
        isLoadingFields: true,
      };
    case GET_SALESFORCE_DESCRIBE_EXE_EXPORT_SUCCESS:
      accountFields = {};
      contactFields = {};
      leadFields = {};
      Object.values(action.payload.accountFields).forEach(
        (item) => (accountFields[item.name] = item)
      );
      Object.values(action.payload.contactFields).forEach(
        (item) => (contactFields[item.name] = item)
      );
      Object.values(action.payload.leadFields).forEach(
        (item) => (leadFields[item.name] = item)
      );

      //取引先名 is not included in describe results for some reasons,
      //so we will hardcode it for now
      accountFields["Name"] = {
        label: "取引先名",
        name: "Name",
        type: "string",
        soapType: "tns:Name",
        isRequired: "true",
      };

      return {
        ...state,
        isLoadingFields: false,
        accountFields: accountFields,
        contactFields: contactFields,
        leadFields: leadFields,
      };
    case GET_SALESFORCE_DESCRIBE_EXE_EXPORT_FAILURE:
      return {
        ...state,
        isLoadingFields: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case POST_SALESFORCE_EXPORT_MAPPINGS_EXE_REQUEST:
      return {
        ...state,
        isConfiguring: true,
      };
    case POST_SALESFORCE_EXPORT_MAPPINGS_EXE_SUCCESS:
      return {
        ...state,
        shortMessage: messages.SAVE_SUCCESS,
        isConfiguring: false,
      };
    case POST_SALESFORCE_EXPORT_MAPPINGS_EXE_FAILURE:
      return {
        ...state,
        isConfiguring: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_POST_SALESFORCE_CONFIG_FAILURE
        ),
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case GET_SALESFORCE_EXPORT_MAPPINGS_REQUEST:
      return {
        ...state,
        isLoadingMapping: true,
      };
    case GET_SALESFORCE_EXPORT_MAPPINGS_SUCCESS:
      return {
        ...state,
        mapping: action.payload.mapping,
        isLoadingMapping: false,
      };
    case GET_SALESFORCE_EXPORT_MAPPINGS_FAILURE:
      return {
        ...state,
        isLoadingMapping: false,
        mapping: initialState.mapping,
      };
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/salesforceExeSetting.js